import type { TFnType } from "@tolgee/react";

const ROLE_KEYS: Record<string, { key: string; defaultValue: string }> = {
  organiser: {
    key: "common.impersonation.role.organiser",
    defaultValue: "organiser",
  },
  admin: { key: "common.impersonation.role.admin", defaultValue: "admin" },
};

/**
 * The returning account's role in the UI's language (FS-3326). `/me` sends it
 * as a raw `Roles` value; one with no key here is shown as it comes.
 */
export const impersonatorRoleLabel = (
  role: string | undefined,
  t: TFnType
): string | undefined => {
  const entry = role ? ROLE_KEYS[role] : undefined;

  return entry ? t(entry) : role;
};
